import React from "react";
import BigWinReport from "../modules/BigWinReport";

export default function BigWinReportPage() {
    return <BigWinReport/>
}